import {useGetProductReport} from '../hooks/useGetProductReport'
import {ProductReportContext} from '../context'
import {KTCard} from '../../../_metronic/helpers'
import ProductReportHeader from '../sections/header/ProductReportHeader'
import ProductReportTable from '../sections/table/ProductReportTable'
import useGetPurchasers from '../hooks/useGetPurchasers'
import { Pagination } from '../../../utils/pagination'

function ProductReport() {
  const {
    reportData,
    isLoading,
    filters,
    onSearch,
    onDaysChange,
    onPurchaserChange,
    onHideDiscontinuedChange,
    pagination,
    onPageChange,
    onSortingChange,
    onDownloadCsv,
    isFetchingCsvData,
  } = useGetProductReport()

  const {purchasers, isLoading: isPurchasersLoading} = useGetPurchasers()

  const contextValue = {
    reportData,
    isLoading,
    filters,
    onSearch,
    onDaysChange,
    onPurchaserChange,
    onHideDiscontinuedChange,
    purchasers,
    isPurchasersLoading,
    pagination,
    onPageChange,
    onSortingChange,  
    onDownloadCsv,
    isFetchingCsvData,
  }

  return (
    <KTCard>
      <ProductReportContext.Provider value={contextValue}>
        <ProductReportHeader />
        <ProductReportTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </ProductReportContext.Provider>
    </KTCard>
  )
}

export default ProductReport
